var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-container',{attrs:{"id":"viewport","direction":"vertical"}},[_c('main-header'),_c('el-container',[_c('el-main',[_c('router-view')],1)],1),_c('main-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }